// Operational Service capability helpers (v1.0).
//
// Per docs/planning/service_bucket.md §5.4, the Service bucket (Board,
// Requests, Scheduling, etc.) is gated by `organizations.services_enabled`
// (default false). Service offerings are managed in Service setup; job types
// in Service setup → Advanced. Proposal copy lives in Manager → Documents Editor.
//
// Mirrors `src/lib/fulfillment/salesFloorCapability.ts`.

export const SERVICE_OPERATIONAL_BUCKET_MODES = [
  "serviceDefinitions",
  "serviceBoard",
  "serviceRequests",
  "serviceScheduling",
  "serviceMaterialsUsage",
] as const;

export type ServiceOperationalBucketMode = (typeof SERVICE_OPERATIONAL_BUCKET_MODES)[number];

export function isServiceOperationalBucketMode(mode: string): mode is ServiceOperationalBucketMode {
  return (SERVICE_OPERATIONAL_BUCKET_MODES as readonly string[]).includes(mode);
}

/** Defensive boolean coercion. Anything other than literal `true` returns false (fail closed). */
export function coerceServicesEnabled(raw: unknown): boolean {
  return raw === true;
}

/** Returns true iff this mode requires `services_enabled=true` on the active org. */
export function requiresServicesEnabled(mode: string): boolean {
  return isServiceOperationalBucketMode(mode);
}

